import shaderFragment from '../../shaders/blur/fragment.glsl'
import shaderVertex from '../../shaders/blur/vertex.glsl'

export default {
    uniforms: {
        tDiffuse: { value: null },
        uResolution: { value: null },
        uStrength: { value: null }
    },
    vertexShader: shaderVertex,
    fragmentShader: shaderFragment
}
